exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".totalCellWrapper-23f19{font-weight:bold}", ""]);

// Exports
exports.locals = {
	"totalCellWrapper": "totalCellWrapper-23f19"
};